<template>
  <div class="grid content-center h-full w-full px-6">
    <DeckVideoPlayer ref="videoPlayerRef" :key="slide.url" :autoplay="autoplay" :options="{ src: slide.url }" @ended="emitResumeAutoplay" />
  </div>
</template>

<script lang="ts" setup>
import type { PropType, DeepReadonly } from 'vue'
import { ref } from 'vue'

import type { Slide } from '@/entities/deck'
import { AUTOPLAY_DELAY } from '@/composables/useAutoPlay'

const props = defineProps({
  autoplay: {
    type: Boolean,
    default: false,
  },
  slide: {
    type: Object as PropType<DeepReadonly<Slide>>,
    required: true,
  },
})

const emit = defineEmits(['pause-autoplay', 'resume-autoplay'])

const videoPlayerRef = ref<any | null>(null)

if (props.autoplay) {
  emit('pause-autoplay')

  const resumeIfNotStarted = () => {
    const { currentTime } = videoPlayerRef.value?.videoRef!

    if (currentTime === 0) emit('resume-autoplay')
  }

  setTimeout(resumeIfNotStarted, AUTOPLAY_DELAY)
}

const emitResumeAutoplay = () => {
  if (props.autoplay) emit('resume-autoplay')
}
</script>
